/**
 * Contract for the `toggleforumreplyflag` callable, imported by both the
 * handler and the reply view so the two sides cannot drift. Staff (TA and
 * above) flag and unflag replies only through this callable.
 */

import {z} from 'zod';

import {ForumPathSegmentSchema} from './publishForumReplyApi';

/** Deployed name of the callable. */
export const TOGGLE_FORUM_REPLY_FLAG_FUNCTION_NAME = 'toggleforumreplyflag';

/** Request body of `toggleforumreplyflag`. */
export const ToggleForumReplyFlagRequestSchema = z.object({
  /** The course the forum belongs to. */
  courseId: ForumPathSegmentSchema,
  /** The forum the reply belongs to. */
  forumId: ForumPathSegmentSchema,
  /** The reply to flag or unflag. */
  replyId: ForumPathSegmentSchema,
  /** True to flag the reply, false to clear the flag. */
  isFlagged: z.boolean(),
});

/** Parsed request body of `toggleforumreplyflag`. */
export type ToggleForumReplyFlagRequest = z.infer<
  typeof ToggleForumReplyFlagRequestSchema
>;
